import dynamic from 'next/dynamic';
import AnnouncementBarTastic from './bar/announcment';
import CategorySliderTastic from './category-slider';
import HeroTastic from './content/hero';
import Tile from './content/tile';
import TilesGroupTastic from './content/tiles-group';
// import ContentSliderTastic from './content-slider';
// import Footer from './footer';
import Header from './header';
import NotFoundTastic from './not-found';
import ProductSlider from './products/slider';
import SpacerTastic from './spacer';
import { TasticRegistry } from './types';
// import ImageContentSliderTastic from './content/image-content-slider';
import ExperienceCenterLocationSpecificTastic from './experience-center/location-specific';
// import ImageOnlySliderTastic from './content/image-only-slider';
// import ImageContentSliderSecondTastic from './content-slider-second';
// import TilesMultipleCTATastic from './content/tiles-multiple-cta';
// import WhyCaromaBannerTastic from './content/why-caroma-banner';
// import ImageOnlySliderSecondTastic from './content/follow-us-slider';
// import NeedRenoSliderTastic from './content/need-reno';
import PDPSidebarTastic from './products/sidebar';
import FAQSectionTastic from './content/faq-section';
import ContactSliderTastic from './content/contact/index';
import WarrantyRegistrationTastic from './content/warrantyregistration/index';
import ExperienceCenterTastic from './experience-center';
import FAQSectionTasticSecond from './content/faq-section-product';
import BathroomTastic from './products/product-list/bathroom';
import OurTechnologiesTastic from './content/our-technologies/cover';
import ContentstackRenderer from './content/our-technologies';
import CollectionTastic from './products/product-list/collection';
import NoResultFoundTastic from './no-result';
import ProductTilesSliderTastic from './products/product-tile-cms';
import ProductSliderAlgoliaTastic from './products/related-products-algolia';
import PrivacyPageTastic from './privacy-page';
import StoreLocatorTastic from './store-locator';
import ScrollToTopTastic from './scroll-to-top';
import OurStoryPageTastic from './our-story';
import RenovationPageTastic from './renovation-guide';
import ProductlistSliderTastic from './products/product-list-cms';
import ProductListYouSliderTastic from './products/product-list-you-like';
import IndependentLivingCategory from './independent-living/category';
import WarrantyTastic from './content/warranty';

const Markdown = dynamic(() => import('./markdown'));
const AccountDetails = dynamic(() => import('./account/details'));
const AccountLogin = dynamic(() => import('./account/login'));
const AccountOrdersHistory = dynamic(() => import('./account/orders'));
const AccountRegister = dynamic(() => import('./account/register'));
const ResetPassword = dynamic(() => import('./account/reset-password'));
const Checkout = dynamic(() => import('./checkout'));
const ThankYou = dynamic(() => import('./thank-you'));
const ProductDetails = dynamic(() => import('./products/details'));
const ProductList = dynamic(() => import('./products/product-list'));
const ProductListAlgolia = dynamic(() => import('./products/product-list-algolia'));
const SimilarProducts = dynamic(() => import('./products/similar-products'));
const OtherProducts = dynamic(() => import('./products/other-products'));
const Showcase = dynamic(() => import('./showcase'));
const Cart = dynamic(() => import('./cart'));
const Footer = dynamic(() => import('./footer'));

const ContentSliderTastic = dynamic(() => import('./content-slider'));
const ImageContentSliderTastic = dynamic(() => import('./content/image-content-slider'));
const ImageOnlySliderTastic = dynamic(() => import('./content/image-only-slider'));
const ImageOnlySliderSecondTastic = dynamic(() => import('./content/follow-us-slider'));
const ImageContentSliderSecondTastic = dynamic(() => import('./content-slider-second'));
const TilesMultipleCTATastic = dynamic(() => import('./content/tiles-multiple-cta'));
const WhyCaromaBannerTastic = dynamic(() => import('./content/why-caroma-banner'));
const NeedRenoSliderTastic = dynamic(() => import('./content/need-reno'));

export const tastics = {
  'commercetools/ui/checkout': Checkout,
  'commercetools/ui/thank-you': ThankYou,
  'commercetools/ui/footer': Footer,
  'commercetools/ui/header': Header,
  'commercetools/ui/content/tile': Tile,
  'commercetools/ui/content/hero': HeroTastic,
  'commercetools/ui/content/spacer': SpacerTastic,
  'commercetools/ui/content/showcase': Showcase,
  'commercetools/ui/content/markdown': Markdown,
  'commercetools/ui/cart': Cart,
  'commercetools/ui/products/details': ProductDetails,
  'commercetools/ui/products/product-list': ProductList,
  'commercetools/ui/products/product-list-algolia': ProductListAlgolia,
  'commercetools/ui/products/slider': ProductSliderAlgoliaTastic,
  'commercetools/ui/product-slider/second': ImageOnlySliderSecondTastic,
  'commercetools/ui/products/similar-products': SimilarProducts,
  'commercetools/ui/products/other-products': OtherProducts,
  'commercetools/ui/account/details': AccountDetails,
  'commercetools/ui/account/login': AccountLogin,
  'commercetools/ui/account/register': AccountRegister,
  'commercetools/ui/account/orders': AccountOrdersHistory,
  'commercetools/ui/account/reset-password': ResetPassword,
  'commercetools/ui/category-slider': CategorySliderTastic,
  'commercetools/ui/content/announcement-bar': AnnouncementBarTastic,
  'commercetools/ui/content/content-slider': ContentSliderTastic,
  'commercetools/ui/content/tiles-group': TilesGroupTastic,
  'commercetools/ui/not-found': NotFoundTastic,
  'homepage/image-content-slider': ImageContentSliderTastic,
  'homepage/image-only-slider': ImageOnlySliderTastic,
  'commercetools/ui/experience-center/location-specific-landing-page': ExperienceCenterLocationSpecificTastic,
  'commercetools/ui/ content-slider/second': ImageContentSliderSecondTastic,
  'homepage/tiles-multiple-cta': TilesMultipleCTATastic,
  'homepage/why-caroma-banner': WhyCaromaBannerTastic,
  'commercetools/ui/need-reno': NeedRenoSliderTastic,
  'commercetools/ui/products/pdp-sidebar': PDPSidebarTastic,
  'commercetools/ui/products/faq-section': FAQSectionTastic,
  'commercetools/ui/contact': ContactSliderTastic,
  'commercetools/ui/warranty-registration': WarrantyRegistrationTastic,
  'commercetools/ui/experience-center/experience-center-landing-page': ExperienceCenterTastic,
  'Content/FAQ/Section': FAQSectionTasticSecond,
  'commercetools/our-technologies': OurTechnologiesTastic,
  'commercetools/cs-renderer': ContentstackRenderer,
  'commercetools/Bathroom': BathroomTastic,
  'commercetools/independent-living/category': IndependentLivingCategory,
  'commercetools/collection': CollectionTastic,
  'commercetools/ui/content/warranty-page': WarrantyTastic,
  'commercetools UI no result found': NoResultFoundTastic,
  'commercetools/ui/products/slider-cms': ProductTilesSliderTastic,
  'commercetools/ui/privacy': PrivacyPageTastic,
  'commercetools/ui/storelocator': StoreLocatorTastic,
  'commercetools/ui/products/scroll-to-top': ScrollToTopTastic,
  'commercetools/ui/our-story': OurStoryPageTastic,
  'commercetools/ui/renovation-guide': RenovationPageTastic,
  'Renovation/guide/Page/Product/CMS': ProductlistSliderTastic,
  'commercetools/UI/product/slider/you-might-also-like': ProductListYouSliderTastic,
} as TasticRegistry;
